import { WorkflowExecution, Workflow } from '@amzn/finspace-service-typescript-client';
import { ActivityItem } from '../components/AllActivities/types';

/**
 * Maps WorkflowExecutionStatus to ActivityItem status
 */
export const mapExecutionStatusToActivityStatus = (status: string): 'Completed' | 'In Progress' | 'Failed' => {
  switch (status) {
    case 'Succeeded':
      return 'Completed';
    case 'Execution In Progress':
    case 'Report Generation In Progress':
    case 'User Input Required':
    case 'Pending':
      return 'In Progress';
    case 'Failed':
      return 'Failed';
    default:
      return 'Failed'; // Default unknown statuses to Failed
  }
};

/**
 * Derives category from workflow tags
 */
export const deriveCategory = (tags?: string[]): string | undefined => {
  if (!tags || tags.length === 0) return undefined;
  
  if (tags.includes('MFR')) return 'MFR';
  if (tags.includes('NetPPM')) return 'NetPPM';
  if (tags.includes('RVM')) return 'RVM';
  if (tags.includes('OPEX')) return 'OPEX';
  
  return tags[0]; // Use first tag as fallback
};

/**
 * Formats date for display
 */
export const formatExecutionDate = (startTime?: string | Date, endTime?: string | Date): string => {
  const date = endTime || startTime;
  if (!date) return 'N/A';
  
  try {
    return new Date(date).toLocaleString();
  } catch {
    return 'Invalid Date';
  }
};

/**
 * Transforms WorkflowExecution and Workflow to ActivityItem
 */
export const transformToActivityItem = (
  execution: WorkflowExecution,
  workflow?: Workflow
): ActivityItem => {
  const category = deriveCategory(workflow?.tags);
  
  return {
    id: execution.id!,
    reportName: workflow?.name || 'Unknown Workflow',
    description: workflow?.description || 'No description available',
    date: formatExecutionDate(execution.startTime, execution.endTime),
    status: mapExecutionStatusToActivityStatus(execution.status!),
    category: category || 'Other',
    completedAt: execution.endTime ? new Date(execution.endTime).toISOString() : undefined,
    createdAt: execution.startTime ? new Date(execution.startTime).toISOString() : undefined,
    actions: {
      viewUrl: `/workflow/execution/${execution.id}`
    }
  };
};
